module.exports = __webpack_public_path__ + "img/img_avatar_male.dc3eb770.png";